/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../app/nls/StringResources'
], function (resources) {


	const FontComboOptions = {

		fontFamily: [{
			'value': 'auto',
			'label': resources.get('textAutoFontSize')
		}, {
			'value': 'anton',
			'label': 'Anton',
			'cssClass': 'rt_fontFamilyAnton'
		}, {
			'value': 'cherrycreamsoda',
			'label': 'Cherry Cream Soda',
			'cssClass': 'rt_fontFamilyCherryCreamSoda'
		}, {
			'value': 'condiment',
			'label': 'Condiment',
			'cssClass': 'rt_fontFamilyCondiment-Regular'
		}, {
			'value': 'didactgothic',
			'label': 'Didact Gothic',
			'cssClass': 'rt_fontFamilyDidactGothic'
		}, {
			'value': 'euphoriascript',
			'label': 'Euphoria Script',
			'cssClass': 'rt_fontFamilyEuphoriaScript-Regular'
		}, {
			'value': 'helvneueforibm',
			'label': 'Helvetica Neue',
			'cssClass': 'rt_fontFamilyHelvNeueforIBM-Regular'
		}, {
			'value': 'kaushanscript',
			'label': 'Kaushan Script',
			'cssClass': 'rt_fontFamilyKaushanScript-Regular'
		}, {
			'value': 'lobster',
			'label': 'Lobster',
			'cssClass': 'rt_fontFamilyLobster'
		}, {
			'value': 'merriweather',
			'label': 'Merriweather',
			'cssClass': 'rt_fontFamilyMerriweather-Regular'
		}, {
			'value': 'merriweathersans',
			'label': 'Merriweather Sans',
			'cssClass': 'rt_fontFamilyMerriweatherSans-Regular'
		}, {
			'value': 'monoton',
			'label': 'Monoton',
			'cssClass': 'rt_fontFamilyMonoton-Regular'
		}, {
			'value': 'montserrat',
			'label': 'Montserrat',
			'cssClass': 'rt_fontFamilyMontserrat-Regular'
		}, {
			'value': 'opensanscondensed',
			'label': 'Open Sans Condensed',
			'cssClass': 'rt_fontFamilyOpenSansCondensed-Regular'
		}, {
			'value': 'oswald',
			'label': 'Oswald',
			'cssClass': 'rt_fontFamilyOswald-Regular'
		}, {
			'value': 'playball',
			'label': 'Playball',
			'cssClass': 'rt_fontFamilyPlayball'
		}, {
			'value': 'ibmplexsans',
			'label': 'IBM Plex',
			'cssClass': 'rt_fontFamilyPlex-Regular'
		}, {
			'value': 'roboto',
			'label': 'Roboto',
			'cssClass': 'rt_fontFamilyRoboto-Regular'
		}, {
			'value': 'sortsmillgoudy',
			'label': 'Sorts Mill Goudy',
			'cssClass': 'rt_fontFamilySortsMillGoudy-Regular'
		}, {
			'value': 'specialelite',
			'label': 'Special Elite',
			'cssClass': 'rt_fontFamilySpecialElite'
		}],

		fontSize: [{
			'value': 'auto',
			'label': resources.get('textAutoFontSize')
		}, {
			'value': '8',
			'label': '8'
		}, {
			'value': '9',
			'label': '9'
		}, {
			'value': '10',
			'label': '10'
		}, {
			'value': '11',
			'label': '11'
		}, {
			'value': '12',
			'label': '12'
		}, {
			'value': '14',
			'label': '14'
		}, {
			'value': '16',
			'label': '16'
		}, {
			'value': '18',
			'label': '18'
		}, {
			'value': '20',
			'label': '20'
		}, {
			'value': '22',
			'label': '22'
		}, {
			'value': '24',
			'label': '24'
		}, {
			'value': '26',
			'label': '26'
		}, {
			'value': '28',
			'label': '28'
		}, {
			'value': '30',
			'label': '30'
		}, {
			'value': '36',
			'label': '36'
		}, {
			'value': '48',
			'label': '48'
		}, {
			'value': '60',
			'label': '60'
		}, {
			'value': '72',
			'label': '72'
		}, {
			'value': '96',
			'label': '96'
		}, {
			'value': '120',
			'label': '120'
		}, {
			'value': '170',
			'label': '170'
		}, {
			'value': '230',
			'label': '230'
		}],

		fontFamilyLabel: resources.get('textFontFamily'),
		fontSizeLabel: resources.get('textFontSize'),

		textColor: {
			label: resources.get('textFontColor'),
			addButton: true
		}
	};

	return FontComboOptions;
});
